var map = {
	"./ItemsChs.js": [
		6906,
		[
			906
		]
	],
	"./ItemsCht.js": [
		4419,
		[
			419
		]
	],
	"./ItemsEn.js": [
		7971,
		[]
	],
	"./ItemsEs.js": [
		7864,
		[]
	],
	"./ItemsEsLa.js": [
		6864,
		[]
	],
	"./ItemsFre.js": [
		7294,
		[]
	],
	"./ItemsGer.js": [
		2000,
		[]
	],
	"./ItemsIta.js": [
		8886,
		[]
	],
	"./ItemsJpn.js": [
		7334,
		[
			334
		]
	],
	"./ItemsKor.js": [
		5934,
		[
			934
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2092;
module.exports = webpackAsyncContext;